import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import SymbolLegendItem from './_partials/SymbolLegendItem';
import UserSymbolsFooter from './_partials/UserSymbolsFooter';
import { SYMBOLS_LIST } from './constants';
import s from './UserSymbolsPopup.scss';
const UserSymbolsPopup = ({ isLoggedIn, hasCoreMembership, requestClose })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Modal, {
        isOpen: true,
        className: s['popup'],
        heading: t('userSymbolsPopup.v2.title'),
        footer: /*#__PURE__*/ React.createElement(UserSymbolsFooter, {
            isLoggedIn: isLoggedIn,
            hasCoreMembership: hasCoreMembership,
            requestClose: requestClose
        }),
        layoutClassName: s['layout'],
        onRequestClose: requestClose
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['symbols-container']
    }, SYMBOLS_LIST.map((legend, idx)=>/*#__PURE__*/ React.createElement(SymbolLegendItem, _object_spread({
            key: `symbol-${idx}`,
            className: s['symbol-item']
        }, legend)))));
};
UserSymbolsPopup.displayName = 'UserSymbolsPopup';
export default UserSymbolsPopup;

//# sourceMappingURL=UserSymbolsPopup.js.map